import clsx from 'clsx';
import styles from 'components/UI/V3/Table/HeaderCell/TableHeaderCell.module.scss';
import React from 'react';

type TableHeaderCellProps = React.ComponentProps<'th'>;

export const TableHeaderCell: React.FC<TableHeaderCellProps> = ({ children, className, ...props }) => {
    return (
        <th
            className={clsx(styles.root, className)}
            {...props}
        >
            {children}
        </th>
    );
};
